<div style="text-align: center;background-color: blue;color: white;padding: 10px;display: flex;justify-content: space-between;align-items: center;margin: -20px -20px 20px -20px;">
    <span>{{ data.isEditing ? 'Edit Lead Condition' : 'Add New Condition' }}</span>
    <button (click)="onCancel()" style="background: none;border: none;color: white;font-size: 20px;cursor: pointer;">
        <i class="fas fa-times"></i>
    </button>
</div>
<table>
    <tr>
        <th style="padding-left: 10px !important;">Condition Name : </th>
        <th>
            <input type="text" [(ngModel)]="model.conditionName" name="conditionName" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">If Source : </th>
        <th>
            <select [(ngModel)]="model.leadSourceId" name="leadSourceId">
                <option value="0" disabled>Select</option>
                <option *ngFor="let item of sources | async" [value]="item.refNo">{{item.sourceName}}</option>
            </select>
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Then assign to : </th>
        <th>
            <select [(ngModel)]="model.userId" name="userId">
                <option value="0" disabled>Select</option>
                <option *ngFor="let item of users | async" [value]="item.refNo">{{item.userName}}</option>
            </select>
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Assign Method : </th>
        <th>
            <select [(ngModel)]="model.assignLead" name="assignLead" (change)="assignLeadTypeChanged($event)">
                <option value="0" disabled>Select</option>
                <option value="Randomly">Randomly</option>
                <option value="Sequentially">Sequentially</option>
            </select>
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Leads at time : </th>
        <th>
            <input type="number" [(ngModel)]="model.leadsAtATime" name="leadsAtATime" />
        </th>
    </tr>
</table>
<br />
<div style="display: flex; gap: 5px; justify-content: flex-end; flex-wrap: nowrap;">
    <button class="btn btn-sm btn-secondary" (click)="onCancel();" style="white-space: nowrap;">
        <i class="fas fa-times"></i> Cancel
    </button>
    <button class="btn btn-sm btn-primary" (click)="onSave();" style="white-space: nowrap;">
        <i class="fas fa-plus"></i> Save
    </button>
</div>